import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2550d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable" }

import { computed, nextTick, ref } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  required: { type: Boolean, required: false, default: true },
  modelValue: { type: String, required: false, default: "" },
  title: { type: String, required: false, default: "" },
  label: { type: String, required: false, default: "" },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef

const editing = ref(false);
const valid = computed(() => {
  return !props.required || value.value != undefined;
});
const editor = ref();

const startEdit = async () => {
  editing.value = true;
  await nextTick();
  editor.value.focus();
};
const endEdit = () => {
  emit("update:modelValue", intValue.value);
  editing.value = false;
};

const intValue = ref(props.modelValue);
const value = computed({
  get: () => intValue.value,
  set: (value) => {
    intValue.value = value;
  },
});

const messages = props.required ? "Required" : "";

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      onClick: startEdit,
      class: "groupName"
    }, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(value)), 1),
      _createVNode(_component_va_icon, {
        class: "editable",
        name: "edit",
        size: 12
      })
    ], 512), [
      [_vShow, !editing.value]
    ]),
    _withDirectives(_createVNode(_component_va_input, {
      label: __props.label,
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      onBlur: endEdit,
      onKeyup: _withKeys(endEdit, ["enter"]),
      messages: _unref(messages),
      success: _unref(valid),
      ref_key: "editor",
      ref: editor
    }, null, 8, ["label", "modelValue", "onKeyup", "messages", "success"]), [
      [_vShow, editing.value]
    ])
  ], 64))
}
}

})